import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import InboxIcon from '@mui/icons-material/Inbox'
import DraftsIcon from '@mui/icons-material/Drafts'
import styled from 'styled-components'
import { useAppDispatch } from '../../../store'
import { useEffect } from 'react'
import { MenteeMenu } from '../../../models/Enums'
import { setMenuIndex } from '../../../store/userSlice'

type Props = {
  menuIndex: number
  setMenuIndex: React.Dispatch<React.SetStateAction<number>>
}

function Menu(props: Props) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setMenuIndex(MenteeMenu.NONE))
  }, [])

  const handleClick = (index: number) => {
    props.setMenuIndex(index)
  }

  function calculateStandardDeviation(array: number[]): number {
    // Calculate the mean of the array values
    const mean = array.reduce((acc, val) => acc + val, 0) / array.length

    // Calculate the variance
    const variance =
      array.reduce((acc, val) => acc + Math.pow(val - mean, 2), 0) /
      array.length

    // Calculate the standard deviation
    const stdDev = Math.sqrt(variance)

    return stdDev
  }
  function handleChangePassword(): void {
    console.log('handleChangePassword')
  }

  return (
    <Container>
      <BoxFont
        sx={{ width: '80%', maxWidth: 250, bgcolor: 'background.paper' }}
      >
        <nav aria-label="main mailbox folders">
          <List>
            <ListItem>
              <ListItemButton
                selected={props.menuIndex === 0}
                onClick={() => handleClick(0)}
              >
                <ListItemIcon>
                  <InboxIcon />
                </ListItemIcon>
                <ListItemTextSel secondary="내정보" />
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButtonSel
                selected={props.menuIndex === 1}
                onClick={() => handleClick(1)}
              >
                <ListItemIcon>
                  <DraftsIcon />
                </ListItemIcon>
                <ListItemTextSel
                  onClick={() => handleChangePassword()}
                  secondary="암호바꾸기"
                />
              </ListItemButtonSel>
            </ListItem>
          </List>
        </nav>
      </BoxFont>
    </Container>
  )
}

const Container = styled.div`
  grid-area: leftside;
`
const BoxFont = styled(Box)`
  font-size: 100px;
`

const ListItemButtonSel = styled(ListItemButton)({
  '&.Mui-selected': {
    backgroundColor: '#ff9800',
    color: 'black',
  },
  '&.Mui-selected:hover': {
    backgroundColor: '#ff9800',
    color: 'black',
  },
})

const ListItemTextSel = styled(ListItemText)({
  '& .MuiTypography-root': {
    fontSize: '0.85rem',
  },
})

export default Menu
